import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
//import { Select } from 'formik-material-ui';
import Select, { Option, ReactSelectProps } from 'react-select';
import {
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  FormHelperText,
  ListItemText,
  Checkbox,
  Input,
  Button,
} from '@material-ui/core';
import { FormatColorReset } from '@material-ui/icons';
import { useCategoryGetListAll } from './../../../hooks/useData';

const options = [
  {
    value: 1,
    label: 'ข้อมูลพื้นฐานที่ระบุตัวตน เช่น ชื่อ รายละเอียดการติดต่อ',
  },
  { value: 2, label: 'ข้อมูลที่ระบุตัวตน เช่น Username และ Password' },
  {
    value: 3,
    label: 'ข้อมูลด้านการเงิน เช่น Credit Card ID ข้อมูลสถาบันการเงิน',
  },
  { value: 4, label: 'ข้อมูลด้าน Biometric' },
  { value: 5, label: 'ข้อมูลด้านสุขภาพ' },
  { value: 6, label: 'ข้อมูลศาสนาและความเชื่อ' },
  { value: 7, label: 'ข้อมูลเกี่ยวกับความเห็นทางการเมือง' },
  { value: 8, label: 'ข้อมูลเกี่ยวกับเพศและเพศสภาพ' },
  {
    value: 9,
    label: 'ข้อมูลส่วนบุคคลที่เป็นทางการ เช่น Passport ใบขับขี่ บัตรประชาชน',
  },
  { value: 10, label: 'ข้อมูลตำแหน่งสถานที่' },
  { value: 11, label: 'ไม่สามารถระบุได้' },
  { value: 12, label: 'อื่นๆ' },
];
const personalDataCategories = [
  'ข้อมูลพื้นฐานที่ระบุตัวตน เช่น ชื่อ รายละเอียดการติดต่อ',
  'ข้อมูลที่ระบุตัวตน เช่น Username และ Password',
  'ข้อมูลด้านการเงิน เช่น Credit Card ID ข้อมูลสถาบันการเงิน',
  'ข้อมูลด้าน Biometric',
  'ข้อมูลด้านสุขภาพ',
  'ข้อมูลศาสนาและความเชื่อ',
  'ข้อมูลเกี่ยวกับความเห็นทางการเมือง',
  'ข้อมูลเกี่ยวกับเพศและเพศสภาพ',
  'ข้อมูลส่วนบุคคลที่เป็นทางการ เช่น Passport ใบขับขี่ บัตรประชาชน',
  'ข้อมูลตำแหน่งสถานที่',
  'ไม่สามารถระบุได้',
  'อื่นๆ',
];

const customStyles = {
  control: (provide, state) => ({
    flexDirection: 'row',
    display: 'flex',
    border: '1px solid #ccc',
    font: '1.2rem',
  }),
  valueContainer: () => ({
    flexDirection: 'row',
    margin: '5px',
    padding: '5px',
    fontSize: '1rem',
    minWidth: '90%',
  }),
  indicatorsContainer: () => ({
    flexDirection: 'row',
    display: 'flex',
    minWidth: '10%',
  }),
};
/**
 * SelectPersonalDataCategory() (component)
 * @param {string} name, name of select element (default: category_id)
 * @param {string} id, id of select element (default: category_id)
 * @param {string} label, label of select element (default: "ประเภทของข้อมูลส่วนบุคคลที่มีการละเมิด")
 * @param {function} onChange, onChange
 * @param {string|number} value, value of select element
 * @param {Formik.touched} touched
 * @param {Formik.errors} errors
 * @param {object} className, className of select element
 * @returns (element) SelectPersonalDataCategory
 */
const SelectMultiPersonalDataCategory = ({
  name,
  id,
  label = 'ประเภทของข้อมูลส่วนบุคคลที่มีการละเมิด',
  onChange,
  value = '',
  touched,
  errors,
  className,
}) => {
  const [selectedValue, setSelectedValue] = useState([
    // {
    //   value: 1,
    //   label: 'ข้อมูลพื้นฐานที่ระบุตัวตน เช่น ชื่อ รายละเอียดการติดต่อ',
    // },
    // { value: 2, label: 'ข้อมูลที่ระบุตัวตน เช่น Username และ Password' },
    // {
    //   value: 3,
    //   label: 'ข้อมูลด้านการเงิน เช่น Credit Card ID ข้อมูลสถาบันการเงิน',
    // },
    // { value: 4, label: 'ข้อมูลด้าน Biometric' },
    // { value: 5, label: 'ข้อมูลด้านสุขภาพ' },
  ]);

  const categorys = (data) => {
    return data.map((el) => ({
      category_id: el.id,
      name:el.name,
    }));
  };

  const categories = categorys(useCategoryGetListAll());


  //Set internal value (selectedValue) when external value is changed
  useEffect(() => {
    setSelectedValue(value);
  }, [value]);

  //const [personName, setPersonName] = React.useState([]);

  //const handleChange = (event) => {
  // setPersonName(event.target.value);
  //  console.log(event);
  //};
  // Handle change select
  const memoHandleChange = useCallback((e) => {
    // let context = typeof c.props.children === 'string' ? c.props.children : '';
    onChange && onChange(e);

    
    setSelectedValue(e);
  });

  let labelPlaceHold = 'เลือกประเภทของข้อมูลส่วนบุคคลที่มีการละเมิด';

  return (
    <React.Fragment>
      <div style={{ marginButton: '5px' }}>
        <InputLabel htmlFor={id}>{label}</InputLabel>
      </div>
      <FormControl
        fullWidth
        disabled={true}
        error={errors && touched ? true : false}
        className={className}
      >
        <Field
          component={Select}
          name={name}
          type="text"
          options={categories}
          isMulti
          onChange={memoHandleChange}
          onBlur={() => {}}
          value={
              categories ? categories.find((option) => option.name === '') : ''
          }
          styles={customStyles}
          placeholder={labelPlaceHold}
          defaultValue={value}
          getOptionLabel={(option) => option.name}
          getOptionValue={(option) => option.category_id}
        />
        <FormHelperText>{touched && errors && errors}</FormHelperText>
      </FormControl>
    </React.Fragment>
  );
};

// Types[, Rules] of props
SelectMultiPersonalDataCategory.propTypes = {
  name: PropTypes.string,
  id: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.any,
};

export default React.memo(SelectMultiPersonalDataCategory);
